import { Component, OnInit } from '@angular/core';
import { ApifirstService } from '../service/apifirst.service';
import { ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dtcdata',
  templateUrl: './dtcdata.component.html',
  styleUrls: ['./dtcdata.component.scss']
})
export class DTCDataComponent implements OnInit {
  currentDTCData: any;
  HistoricDTCData: any;
  DTCData: any;
  showloader:boolean = true;
  highlightCurrent: boolean = false;
  highlightHistory: boolean = false;
  tokenObj: any;
  constructor(private service: ApifirstService,private activateRoute: ActivatedRoute,private translate: TranslateService) { }

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe(data => {
      this.tokenObj = data;
    })
    this.service.rapToken.next(this.tokenObj.token);
    this.translate.use(this.tokenObj['language'].toLowerCase())
    this.requestDTCData(this.tokenObj['vin'],this.tokenObj['userId'],this.tokenObj['userType'],this.tokenObj['language'],this.tokenObj['countryThree'],this.tokenObj['dealerCode'],90);
  }

  filterDTCData(setDays: any) {
    this.requestDTCData(this.tokenObj['vin'],this.tokenObj['userId'],this.tokenObj['userType'],this.tokenObj['language'],this.tokenObj['countryThree'],this.tokenObj['dealerCode'],setDays);
  }

  requestDTCData(Vin: any, userID: any, userType: any, languageCode: any, countryCode: any, dealerCode: any,days: any) {
    this.showloader = true;
    this.service.getDTCData(Vin,userID,userType,languageCode,countryCode,dealerCode,days).subscribe((data:any)=> {
      this.showloader = false;
      this.currentDTCData = data.currentDtc;
      this.HistoricDTCData = data.historyDtc;
      if(this.highlightHistory == true) {
        this.getDTCData('historyDTC');
      } else {
        this.getDTCData('currentDTC');
      }
      
    })
  }

  getDTCData(dtcData: any) {
   if(dtcData == 'currentDTC') {
      this.DTCData = this.currentDTCData;
      this.highlightCurrent= true;
      this.highlightHistory = false;
   } else {
      this.highlightCurrent= false;
      this.highlightHistory = true;
      this.DTCData = this.HistoricDTCData;
   }
  }
}
